import type { IconSvgObject } from './types';

const Folder02Icon: IconSvgObject = [
  ["path", { d: "M2 21V4C2 3.44772 2.44772 3 3 3H7.03163C7.3284 3 7.60985 3.13182 7.79985 3.35982L10 6M10 6H7M10 6H18C19.1046 6 20 6.89543 20 8V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.4766 21H2L5.74856 11.6286C5.90042 11.249 6.26813 11 6.67703 11H20.9995C21.707 11 22.1908 11.7145 21.928 12.3714L18.4766 21Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Folder02Icon;
